import React, { Component } from 'react';
import {NavLink} from 'react-router-dom'
import Icon from '../Icon';

class Navigation extends Component {

    constructor(props)
    {
        super(props)
        this.state = {

        }
    }

    render() {
        return(
            <nav className={`bcs-navigation ${this.props.active ? 'active' : ''} ${this.props.condenseNav ? 'condensed' : ''}`} data-component="navigation">
                <a href="#main-content" className="skip-to-content hide" tabIndex="0">Skip To Content</a>
                <div className="course-list">
                    <nav>
                        <ul>
                            <li>
                                <NavLink exact to="/" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Brand" title="Brand">
                                    <Icon icon="download" options="fa-fw" ariaHidden="false" /> Installation
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/best-practices" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Best Practices" title="Best Practices">
                                    <Icon icon="trophy" options="fa-fw" ariaHidden="false"/> Best Practices
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/accessibility" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Accessibility" title="Accessibility">
                                    <Icon icon="universal-access" options="fa-fw" ariaHidden="false"/> Accessibility
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/grid" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Grid" title="Grid">
                                    <Icon icon="th" options="fa-fw" ariaHidden="false"/> Grid
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/typography" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Typography" title="Typography">
                                    <Icon icon="text-height" options="fa-fw" ariaHidden="false"/> Typography
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/forms" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Forms" title="Forms">
                                    <Icon icon="align-justify" options="fa-fw" ariaHidden="false"/> Forms
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/buttons" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Buttons" title="Buttons">
                                    <Icon icon="location-arrow" options="fa-fw" ariaHidden="false"/> Buttons
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/containers" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Cards" title="Cards">
                                    <Icon icon="box" options="fa-fw" ariaHidden="false"/> Containers
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/tables" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Tables" title="Tables">
                                    <Icon icon="table" options="fa-fw" ariaHidden="false"/> Tables
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/calendar" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Calendar" title="Calendar">
                                    <Icon icon="calendar-alt" options="fa-fw" ariaHidden="false"/> Calendar
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/tabs" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Tabs" title="Tabs">
                                    <Icon icon="folder" options="fa-fw" ariaHidden="false"/> Tabs
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/markdown" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Markdown" title="Markdown">
                                    <Icon icon="edit" options="fa-fw" ariaHidden="false"/> Markdown
                                </NavLink>
                            </li>
                            <li>
                                <NavLink exact to="/brand" activeClassName="active" role="menuitem" tabIndex="0" aria-label="Brand" title="Brand">
                                    <Icon icon="trademark" options="fa-fw" ariaHidden="false" /> Brand
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </nav>
        )
    }

}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js